import Spinner from '../common/Spinner';
import EmptyState from '../common/EmptyState';
import DateGroupHeader from './DateGroupHeader';
import InvoiceListItem from './InvoiceListItem';

export default function InvoiceList({ invoices, dailyLimit, type, onOpen, onDelete, onDownload, loading }) {
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 60 }}>
        <Spinner dark /> <span style={{ marginLeft: 10, color: 'var(--muted)' }}>Loading invoices…</span>
      </div>
    );
  }

  if (!invoices.length) {
    return (
      <EmptyState
        title={`No ${type} invoices yet`}
        sub="Upload receipts or create manually to get started."
      />
    );
  }

  const byDate = invoices.reduce((acc, inv) => {
    (acc[inv.date || '?'] = acc[inv.date || '?'] || []).push(inv);
    return acc;
  }, {});

  return (
    <div className="invoice-list">
      {Object.entries(byDate).sort(([a], [b]) => b.localeCompare(a)).map(([date, invs]) => {
        const dayTotal = invs.reduce((s, i) => s + (i.grandTotal || 0), 0);
        return (
          <div className="date-group" key={date}>
            <DateGroupHeader date={date} dayTotal={dayTotal} type={type} dailyLimit={dailyLimit} />
            {invs.map(inv => (
              <InvoiceListItem key={inv._id} invoice={inv} onOpen={onOpen} onDelete={onDelete} onDownload={onDownload} />
            ))}
          </div>
        );
      })}
    </div>
  );
}
